import classNames from 'classnames'
import { ReactNode } from 'react'
import { Text, TextProps } from '../../atoms'
import styles from './index.module.css'

export type LayoutFormMaxWidth = 'max-2xl' | 'max-3xl' | 'max-4xl' | 'max-5xl'

interface LayoutFormProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  maxWidth?: LayoutFormMaxWidth
  titleContainer?: ReactNode
  columns?: '2'
}
export const LayoutForm = ({ maxWidth = 'max-3xl', columns, children, className, ...props }: LayoutFormProps) => {
  return (
    <div
      {...props}
      className={classNames(className, styles.form, styles[maxWidth], columns && styles['columns-' + columns])}
    >
      {children}
    </div>
  )
}

interface LayoutFormRowProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  columns: number
}
export const LayoutFormRow = ({ columns, className, children, ...props }: LayoutFormRowProps) => {
  return (
    <div data-columns={columns} className={classNames(className, styles.row)} {...props}>
      {children}
    </div>
  )
}

interface LayoutFormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  columns: number
}
export const LayoutFormGrid = ({ columns, className, children, ...props }: LayoutFormGridProps) => {
  return (
    <div className={classNames(className, styles.formGrid, styles['columns-' + columns])} {...props}>
      {children}
    </div>
  )
}

interface LayoutFormSectionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  children: ReactNode
  title?: ReactNode
  titleOptions?: Omit<TextProps, 'children'>
  description?: ReactNode
  descriptionOptions?: TextProps
}
export const LayoutFormSection = ({
  title,
  titleOptions,
  descriptionOptions,
  description,
  className,
  children,
  ...props
}: LayoutFormSectionProps) => {
  return (
    <div className={classNames(className, styles.section)} {...props}>
      {title && (
        <LayoutFormTitle
          title={title}
          titleOptions={titleOptions}
          description={description}
          descriptionOptions={descriptionOptions}
        />
      )}
      {children}
    </div>
  )
}

interface LayoutFormTitleProps {
  title?: ReactNode
  titleOptions?: Omit<TextProps, 'children'>
  description?: ReactNode
  descriptionOptions?: TextProps
  containerClassName?: string
}
export const LayoutFormTitle = ({
  title,
  titleOptions,
  description,
  descriptionOptions,
  containerClassName
}: LayoutFormTitleProps) => (
  <div className={classNames(containerClassName, 'mb-4')}>
    <Text as="h2" textType="lg" {...titleOptions}>
      {title}
    </Text>
    {description && (
      <Text
        as="p"
        textType="base"
        {...descriptionOptions}
        className={classNames(descriptionOptions?.className, 'mt-2')}
      >
        {description}
      </Text>
    )}
  </div>
)
